import React from 'react';
import {CommonEdit} from '../Common';
import {getInputs} from './Common';

export const MaterialIndexValuesEdit = props => (
  <CommonEdit {...props} fields={getInputs()} />
);
